import packageJson from "../../../../../package.json"
import { SettingGroup } from "../types"
import { SettingStore } from "~models/setting-store"

const APP_VERSION = packageJson.version || ""

type GeneralSchemaDeps = {
  settingStore?: SettingStore
}
export const generalSchema = ({
  settingStore,
}: GeneralSchemaDeps): SettingGroup[] => [
    {
        title: "",
        contents: [
            {
                id: "general.fontSize",
                type: "navigate",
                title: "字体大小",
                content: "",
                suffix: {
                    type: "text",
                    value: "中",
                },
                icon: "ztdx",
                iconColor: "#4e98f3",
                iconSize: 16,
                bg: "rgba(78, 152, 243, 0.1)"
            },
            {
                id: "general.language",
                type: "navigate",
                title: "语言",
                content: "",
                suffix: {
                    type: "text",
                    value: "跟随系统",
                },
                icon: "yuyan",
                iconColor: "#ff6565",
                iconSize: 15,
                bg: "rgba(255, 101, 101, 0.1)"
            },
            // {
            //     id: "general.qingee",
            //     type: "link",
            //     title: "企鹅官网",
            //     content: "https://www.qingee.com",
            //     suffix: {
            //         type: "text",
            //         value: "官网",
            //     },
            //     icon: "fx",
            //     iconColor: "#19986f",
            //     iconSize: 16,
            //     bg: "rgba(25, 152, 111, 0.1)"
            // },
            {
                id: "general.loginDevice",
                type: "navigate",
                title: "登录设备",
                content: "查看登录历史设备",
                suffix: {
                    type: "text",
                    value: "历史设备",
                },
                icon: "ipad",
                iconColor: "#19986f",
                iconSize: 16,
                bg: "rgba(25, 152, 111, 0.1)"
            },
            // {
            //     id: "general.clearData",
            //     type: "navigate",
            //     title: "清理数据",
            //     content: "",
            //     suffix: {
            //         type: "text",
            //         value: "数据",
            //     },
            //     icon: "delete",
            //     iconColor: "#19986f",
            //     iconSize: 16,
            //     bg: "rgba(25, 152, 111, 0.1)"
            // },
            {
                id: "general.version",
                type: "info",
                title: "版本",
                content: "",
                suffix: {
                    type: "text",
                    value: APP_VERSION ? `v${APP_VERSION}` : "",
                },
                icon: "wxts",
                iconColor: "#4e98f3",
                iconSize: 16,
                bg: "rgba(78, 152, 243, 0.1)"
            },
            {
                id: "general.logout",
                type: "danger",
                title: "退出登录",
                content: "",
                suffix: {
                    type: "text",
                    value: "",
                },
                icon: "tuichu1",
                iconColor: "#ff6565",
                iconSize: 15,
                bg: "rgba(255, 101, 101, 0.1)"
            },
        ]
    }
]
